(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignNextSteps', {
    bindings: {
      campaignId: '<',
      userSettings: '<',
      hidePanel: '&',
      showOfferTab: '&'
    },
    controller: CampaignNextStepsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/campaigns/next-steps.view.html'
  });

  function CampaignNextStepsController(
    userSettingsService,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.hideCampaignNextStep = hideCampaignNextStep;
    vm.scrollToPanel = scrollToPanel;
    vm.cancelHideNextStepsPanel = cancelHideNextStepsPanel;

    function hideCampaignNextStep() {
      vm.hidePanel();
      vm.userSettings.campaignNextSteps[vm.campaignId] = false;
      if (vm.hideAllNextSteps) {
        vm.userSettings.neverShowCampaignNextSteps = true;
      }
      return userSettingsService.saveUserSettings(vm.userSettings);
    }

    function cancelHideNextStepsPanel() {
      vm.showConfirmation = false;
    }

    function scrollToPanel(stepNumber) {
      let panelId;
      switch (stepNumber) {
      case 1:
        panelId = 'panel-call-tracking-tag';
        break;
      case 2:
        panelId = 'panel-payout-settings';
        break;
      case 3:
        panelId = 'panel-url-parameters';
        break;
      case 4:
        panelId = 'panel-routing-panel';
        break;
      default:
        return;
      }
      utils.scrollToElementId(panelId, 52);
    }

  }
})();
